import React from 'react';
import { CatalogosServiciosVista } from '../../vista/catalogosServiciosVista';
import { useEdicionFilas, type ICoordinacionEdicionProps } from '../../../../globales/componentes/tabla/useEdicionFilas';
import { configuracionServiciosInicial, generarIdTemporal } from '../../interfaces';
import type { IFactorServicio, IFactorVelocidadServicio } from '../../../../modelos/CotizadorServicios/entidades/IParametrosServicios';

/** Catálogos con factor: se agregan, editan y eliminan fila por fila. */
export const CatalogosServiciosCV: React.FC<ICoordinacionEdicionProps> = (coordinacion) => {
    const catalogo = (clave: string, datosIniciales: IFactorServicio[]) => ({
        ...coordinacion,
        clave,
        datosIniciales,
        camposObligatorios: ['Nombre', 'Factor'] as (keyof IFactorServicio)[],
        crearFila: (): IFactorServicio => ({ Id: generarIdTemporal(), Nombre: '', Factor: 1 }),
        permiteEliminar: true
    });
    const velocidades = (clave: string, datosIniciales: IFactorVelocidadServicio[]) => ({
        ...coordinacion,
        clave,
        datosIniciales,
        camposObligatorios: ['Velocidad', 'Factor'] as (keyof IFactorVelocidadServicio)[],
        crearFila: (): IFactorVelocidadServicio => ({ Id: generarIdTemporal(), Velocidad: '' as unknown as number, Factor: 1 }),
        permiteEliminar: true
    });

    const c = configuracionServiciosInicial;
    const velocidadesAscensor = useEdicionFilas(velocidades('velocidadesAscensor', c.VelocidadesAscensor));
    const tiposUso = useEdicionFilas(catalogo('tiposUso', c.TiposUso));
    const tiposEquipoEscalera = useEdicionFilas(catalogo('tiposEquipoEscalera', c.TiposEquipoEscalera));
    const velocidadesEscalera = useEdicionFilas(velocidades('velocidadesEscalera', c.VelocidadesEscalera));
    const entornosOperativos = useEdicionFilas(catalogo('entornosOperativos', c.EntornosOperativos));
    const horariosTrabajo = useEdicionFilas(catalogo('horariosTrabajo', c.HorariosTrabajo));
    const cuartoMaquinas = useEdicionFilas(catalogo('cuartoMaquinas', c.CuartoMaquinas));
    const apf = useEdicionFilas(catalogo('apf', c.Apf));

    return (
        <CatalogosServiciosVista
            velocidadesAscensor={velocidadesAscensor}
            tiposUso={tiposUso}
            tiposEquipoEscalera={tiposEquipoEscalera}
            velocidadesEscalera={velocidadesEscalera}
            entornosOperativos={entornosOperativos}
            horariosTrabajo={horariosTrabajo}
            cuartoMaquinas={cuartoMaquinas}
            apf={apf}
        />
    );
};
